import { render } from "./MainContent.vue?vue&type=template&id=31d631de&ts=true"
import script from "./MainContent.vue?vue&type=script&lang=ts"
export * from "./MainContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__